import { TableRow } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export default withStyles({
  root: {
    position: 'relative',
    backgroundClip: 'content-box',
    backgroundColor: '#fff',
  }
})(TableRow);